import { useInitialState } from "../_";
import { EnvironmentOutlined } from '@ant-design/icons';
import { Button, Select, Space } from 'antd';
import React from 'react';
import { useStyles } from "./_.style";
import { SuperHeaderAvatarContainerId } from "./Avatar";
export var SuperHeader = function SuperHeader() {
  var _useInitialState = useInitialState(),
    initialState = _useInitialState.initialState;
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.containerLeft
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Logo",
    src: "/favicon.png"
  }), /*#__PURE__*/React.createElement("span", null, initialState.settings.layout.title)), /*#__PURE__*/React.createElement("div", {
    className: styles.containerCenter
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.containerRight
  }, /*#__PURE__*/React.createElement(Select, {
    defaultValue: "primary",
    style: {
      maxWidth: 256,
      minWidth: 128,
      marginRight: 4
    },
    className: styles.containerTopRightSelector,
    options: [{
      value: 'primary',
      label: /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(EnvironmentOutlined, null), /*#__PURE__*/React.createElement("span", null, "Primary"))
    }]
  }), /*#__PURE__*/React.createElement(Button, {
    className: styles.containerTopRightAvatar,
    id: SuperHeaderAvatarContainerId,
    type: "text"
  })));
};